<template>
  <tr>
    <td>
      <div class="d-flex align-items-center">
        <label class="checkbox checkbox-lg checkbox-outline checkbox-success">
          <input
            type="checkbox"
            name=""
            v-model="local_item.is_active"
            @change="is_active_updated"
          />
          <span></span>
        </label>
        <span class="ml-3 cursor-pointer"></span>
      </div>
    </td>


    <td>
      <span class="d-block font-size-lg">{{ local_item.name }}</span>
    </td>


    <!-- <td>
      <span class="d-block font-size-lg">{{ getTypeString(template.type) }}</span>
    </td> -->
    <td class="text-right pr-0">
      <a
        href="#"
        class="btn btn-icon btn-light btn-sm mx-3"
        @click="select_term_clicked"
      >
        <span class="svg-icon svg-icon-md svg-icon-primary">
          <!--begin::Svg Icon-->
          <inline-svg src="/assets/svg/pencil-square.svg"></inline-svg>
          <!--end::Svg Icon-->
        </span>
      </a>
      <a
        href="#"
        class="btn btn-icon btn-light btn-sm mx-3"
        @click="delete_term_clicked"
      >
        <span class="svg-icon svg-icon-md svg-icon-primary">
          <!--begin::Svg Icon-->
          <inline-svg src="/assets/svg/trash2.svg"></inline-svg>
          <!--end::Svg Icon-->
        </span>
      </a>
    </td>
  </tr>
</template>
<style lang="scss" scoped>
.checkbox > span {
  background-color: white;
  border: 1px solid #ddd;
}
</style>
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'FormPageConfirmTermsTableRow',
  props: ['item'],
  emits: ['select_term_clicked', 'delete_term_clicked', 'is_active_changed'],
  mixins: [ toasts ],
  computed: {
    ...mapGetters(['currentCompanyId'])
  },
  data() {
    return {
      
      local_item: {}
    };
  },

  mounted() {

    this.local_item = { ...this.item };

  },
  watch: {

    item: {
      deep: true,
      handler(val) {
        this.local_item = { ...this.item };
      }
    }
  },
  methods: {
    select_term_clicked() {
      this.$emit('select_term_clicked', this.local_item.id);
    },

    delete_term_clicked() {
      this.$emit('delete_term_clicked', this.local_item.id);
    },

    is_active_updated() {
      this.$emit('is_active_changed', this.local_item.id, this.local_item.is_active);
    }
  }
};
</script>
